export const en = {
    'not-found': 'No results found',
    'not-selected': 'Nothing selected',
    'search-placeholder': 'Search for experiments',
    title: 'Active experiments'
};
